import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/api";

// Redux thunk for SSO token creation
export const createSsoToken = createAsyncThunk(
  "sso/createToken",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post("/sso/create-token", {});
      // response.data: { success, token, redirectUrl }
      if (response.data && response.data.success && response.data.redirectUrl) {
        return response.data;
      } else {
        return rejectWithValue("Failed to get SSO redirect URL");
      }
    } catch (err) {
      return rejectWithValue(err.message || "SSO login failed");
    }
  },
);

// SSO slice for loading/error state
const ssoSlice = createSlice({
  name: "sso",
  initialState: { loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSsoToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSsoToken.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createSsoToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "SSO login failed";
      });
  },
});

export default ssoSlice.reducer;
